import { BaseError } from "../../utils/base-error";

export class ParseError extends BaseError {}
